export const FILES = {
  LOADING: "FILES.LOADING",
  FETCH: "FILES.FETCH",
  FETCH_SUCCESS: "FILES.FETCH_SUCCESS",
  FETCH_ERROR: "FILES.FETCH_ERROR",
  UPLOAD: "FILES.UPLOAD",
  UPLOAD_LEARNING_FILE_DATA: "FILES.UPLOAD_LEARNING_FILE_DATA",
  UPLOAD_LEARNING_FILE_DATA_SUCCESS: "FILES.UPLOAD_LEARNING_FILE_DATA_SUCCESS",
  UPLOAD_LEARNING_FILE_DATA_ERROR: "FILES.UPLOAD_LEARNING_FILE_DATA_ERROR",
  UPLOAD_LEARNING_FILE: "FILES.UPLOAD_LEARNING_FILE",
  UPLOAD_LEARNING_FILE_SUCCESS: "FILES.UPLOAD_LEARNING_FILE_SUCCESS",
  UPLOAD_LEARNING_FILE_ERROR: "FILES.UPLOAD_LEARNING_FILE_ERROR",
  UPLOAD_ERROR: "FILES.UPLOAD_ERROR",
  FETCH_KNOW: "FILES.FETCH_KNOW",
  FETCH_KNOW_SUCCESS: "FILES.FETCH_KNOW_SUCCESS",
  FETCH_KNOW_ERROR: "FILES.FETCH_KNOW_ERROR"
};

export default FILES;
